export enum Bank {
    Kukmin = 'Kukmin',
    Hana = 'Hana',
    Nonghyeop = 'Nonghyeop',
    Uri = 'Uri',
    Kiup = 'Kiup',
    Sinhan = 'Sinhan',
    Kakaobank = 'Kakaobank',
    Tossbank = 'Tossbank',
    Kbank = 'Kbank',
    Saemaul = 'Saemaul',
    Sinhyeop = 'Sinhyeop',
    Woochekuk = 'Woochekuk',
    Sanup = 'Sanup',
    Suhyeop = 'Suhyeop',
    Suchulip = 'Suchulip',
    Jiyeok = 'Jiyeok',
    Jeil = 'Jeil',
    City = 'City',
    Daegu = 'Daegu',
    Busan = 'Busan',
    Guangju = 'Guangju',
    Jeju = 'Jeju',
    JeonBuk = 'JeonBuk',
    Gyeongnam = 'Gyeongnam',
    Jeochuk = 'Jeochuk',
}

export const BankTitleMap: Record<Bank, string> = {
  [Bank.Kukmin]: '국민은행',
  [Bank.Hana]: '하나은행',
  [Bank.Nonghyeop]: '농협은행',
  [Bank.Uri]: '우리은행',
  [Bank.Kiup]: '기업은행',
  [Bank.Sinhan]: '신한은행',
  [Bank.Kakaobank]: '카카오뱅크',
  [Bank.Tossbank]: '토스뱅크',
  [Bank.Kbank]: '케이뱅크',
  [Bank.Saemaul]: '새마을금고',
  [Bank.Sinhyeop]: '신협',
  [Bank.Woochekuk]: '우체국',
  [Bank.Sanup]: '산업은행',
  [Bank.Suhyeop]: '수협은행',
  [Bank.Suchulip]: '수출입은행',
  [Bank.Jiyeok]: '지역농,축협',
  [Bank.Jeil]: 'SC제일은행',
  [Bank.City]: '한국씨티은행',
  [Bank.Daegu]: '대구은행',
  [Bank.Busan]: '부산은행',
  [Bank.Guangju]: '광주은행',
  [Bank.Jeju]: '제주은행',
  [Bank.JeonBuk]: '전북은행',
  [Bank.Gyeongnam]: '경남은행',
  [Bank.Jeochuk]: '저축은행',
};

export const BankLogoMap: Record<Bank, string> = {
  [Bank.Kukmin]: 'assets/kukmin.png',
  [Bank.Hana]: 'assets/hana.png',
  [Bank.Nonghyeop]: 'assets/nonghyeop.png',
  [Bank.Uri]: 'assets/uri.png',
  [Bank.Kiup]: 'assets/kiup.png',
  [Bank.Sinhan]: 'assets/sinhan.png',
  [Bank.Kakaobank]: 'assets/kakaobank.png',
  [Bank.Tossbank]: 'assets/toss.png',
  [Bank.Kbank]: 'assets/kbank.png',
  [Bank.Saemaul]: 'assets/saemaul.png',
  [Bank.Sinhyeop]: 'assets/sinhyeop.png',
  [Bank.Woochekuk]: 'assets/woochekuk.png',
  [Bank.Sanup]: 'assets/sanup.png',
  [Bank.Suhyeop]: 'assets/suhyup.png',
  [Bank.Suchulip]: 'assets/suchulip.png',
  [Bank.Jiyeok]: 'assets/jiyeok.png',
  [Bank.Jeil]: 'assets/jeil.png',
  [Bank.City]: 'assets/city.png',
  [Bank.Daegu]: 'assets/daegu.png',
  [Bank.Busan]: 'assets/busan.png',
  [Bank.Guangju]: 'assets/guanju.png',
  [Bank.Jeju]: 'assets/jeju.png',
  [Bank.JeonBuk]: 'assets/jeonbuk.png',
  [Bank.Gyeongnam]: 'assets/gyeongnam.png',
  [Bank.Jeochuk]: 'assets/jeochuk.png',
};

export const BankList = Object.values(Bank); // ← 배열로 뽑아주기
